module.exports = __webpack_public_path__ + "img/02.fbaaa562.jpg";